import { APP_SHORT_ORG } from "@/branding";
import { cn } from "@/lib/cn";

const LOGO_SRC = "/dataly-cloud-logo.png";

type Size = "xs" | "sm" | "md" | "lg";

const SIZES: Record<Size, { box: string; img: string }> = {
  xs: { box: "h-7 w-7 rounded-md p-1",     img: "max-h-5"  },
  sm: { box: "h-9 w-9 rounded-lg p-1.5",   img: "max-h-6"  },
  md: { box: "h-11 w-11 rounded-lg p-1.5", img: "max-h-7"  },
  lg: { box: "h-14 w-14 rounded-xl p-2",   img: "max-h-9"  },
};

/**
 * Compact, square Dataly Cloud mark for the Apple-style sidebar / auth card.
 * Black plate keeps the metallic gold Dataly logo legible at small sizes.
 */
export function DatalyLogo({ size = "md", className }: { size?: Size; className?: string }) {
  const s = SIZES[size];
  return (
    <div
      className={cn(
        "relative flex shrink-0 items-center justify-center overflow-hidden bg-black",
        s.box,
        className,
      )}
    >
      <img
        src={LOGO_SRC}
        alt={`${APP_SHORT_ORG} logo`}
        className={cn("w-auto max-w-full object-contain", s.img)}
        decoding="async"
      />
    </div>
  );
}
